<template>
  <!-- 视频展示 -->
  <div class="videoListNav">
    <headerNav activeIndex="video"></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="pc">
      <div>
        <div
          style="
            border-bottom: 1px solid #719468;
            padding: 14px 0;
            line-height: 23px;
            margin: 29px auto 0;
            width: 1151px;
            display: flex;
          "
        >
          <div style="font-size: 23px" class="clickBtn1" @click="goHome">
            首页
          </div>
          <div style="font-size: 18px; margin: 0 12px">-</div>
          <div style="font-size: 18px">视频中心</div>
        </div>
      </div>
      <div
        class="display-flex"
        style="
          flex-wrap: wrap;
          width: 1151px;
          justify-content: space-between;
          margin: 29px auto 0;
        "
      >
        <div
          class="videoNav"
          style="width: 540px; margin-top: 69px; cursor: pointer"
          v-for="item of videoList"
          @click="goDetail(item.id)"
        >
          <div style="position:relative;">
            <img
              :src="getUrlPrefix(item.coverImage)"
              style="width: 100%"
              alt=""
            />
            <img src="@/assets/mobile/video.png" style="width:30%;position:absolute;top:120px;left:35%;" alt="">
          </div>
          <li
            style="
              height: 53px;
              line-height: 53px;
              width: 540px;
              color: #fff;
              text-align: center;
              background: #719468;
            "
          >
            <span style="font-size: 21px; margin-right: 17px">{{
              item.title
            }}</span>
            <span style="font-size: 17px">{{ item.releaseTime }}</span>
          </li>
        </div>
      </div>
      <pager
        style="width: 1109px; margin: 35px auto 72px"
        :total="total"
        :pageSize="10"
        :pageNum.sync="currentPage1"
        @goPage="getVideoList()"
      ></pager>
    </div>
    <div class="mobile">
      <div>
        <div
          style="
            margin: 0 auto 0;
            padding: 0.26rem 0 0.2rem;
            text-align: center;
          "
        >
          <div style="font-size: 0.34rem;line-height:1.4;color:#ddd;font-weight: 400;font-family: 'Proxima-Bold', sans-serif;">VIDEO CENTER</div>
          <div style="color:#0f3a3c;font-weight: 600;margin-top:-4px;"  class="fzTitle">视频中心</div>
        </div>
        <div style="padding: 0 0.2rem 0.26rem">
          <el-skeleton :loading="videoList.length === 0" animated>
            <template slot="template">
              <div
                v-for="(item, index) of 2"
                :key="index"
                class="newsList"
                style=""
              >
                <div style="width: 1.35rem; margin-right: 0.14rem">
                  <el-skeleton-item
                    variant="image"
                    style="width: 1.35rem; height: 0.81rem"
                  />
                </div>
                <div style="flex: 1">
                  <div
                    style="
                      margin-bottom: 0.1rem;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <div class="title" style="font-size: 0.13rem; flex: 1">
                      <el-skeleton-item variant="h3" />
                    </div>
                    <div style="color: #535353; font-size: 0.1rem">
                      <el-skeleton-item variant="text" />
                    </div>
                  </div>
                  <div style="font-size: 0.1rem">
                    <el-skeleton-item variant="text" />
                    <el-skeleton-item variant="text" />
                    <el-skeleton-item variant="text" />
                    <el-skeleton-item variant="text" />
                    <el-skeleton-item variant="text" />
                  </div>
                </div>
              </div>
            </template>
            <template>
              <div
                class="display-flex"
                style="
                  flex-wrap: wrap;
                  width: 100%;
                  justify-content: space-between;
                  margin: 0.1rem auto 0;
                "
              >
                <div
                  v-for="(item, index) of videoList"
                  :key="index"
                  style="width: 48%"
                  @click="goDetail(item.id)"
                >
                  <div style="width:100%;position: relative;">
                    <img
                      :src="getUrlPrefix(item.coverImage)"
                      style="width: 100%"
                      alt=""
                    />
                    <img src="@/assets/mobile/video.png" style="width:70%;position:absolute;top:10px;left:15%;" alt="">
                  </div>
                  <li
                    style="
                      width: 100%;
                      color: #fff;
                      text-align: center;
                      background: #719468;
                      display: block;
                      font-size: 0.14rem;
                      line-height:0.3rem;
                    "
                  >
                    <span style="">{{ item.title }}</span>
                  </li>
                </div>
              </div>
            </template>
          </el-skeleton>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from '@/components/headerNav/index'
import bannerNav from '@/components/banner/index'
import footerNav from '@/components/footerNav/index'
import { getVideoList } from '@/api/videoList'
export default {
  name: 'videoList',
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: ["http://yifongwi.oss-cn-hangzhou.aliyuncs.com/navigation/2023/01/05/73a44399-737b-4835-be4c-d4f8e4728b53.png"],
        Mcarousel: ['http://yifongwi.oss-cn-hangzhou.aliyuncs.com/navigation/2023/08/23/2a6e2770-d8ea-46bd-9a4b-de38a84a1c2a.png']
      }, //轮播图
      show: false,
      mobile: false,
      currentPage1: 1,
      total: 0,
      videoList: [],
    }
  },
  mounted() {
    this.getVideoList()
    if(this.isMobile() === true){
      this.postMessage(
          '御方汇植物化妆品原料【官网】',
          '视频中心',
          window.location.href,
          this.getUrlPrefix(this.getBaseInfo().logo)
        );
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push({ name: 'videoListDetail', params: { id: id } })
    },
    goHome() {
      this.$router.push({ name: 'home' })
    },
    getVideoList() {
      //公司新闻
      getVideoList({ pageSize: 10, pageNum: this.currentPage1 }).then(
        (response) => {
          this.videoList = response.data.list
          this.total = response.data.total
        }
      )
    },
  },
}
</script>

<style lang="scss">
.videoListNav {
  .videoNav {
    margin-right: 71px;
  }
  .videoNav:nth-child(2n) {
    margin-right: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/videoList/index.vue